import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import React from 'react';

Sentry.init({
  dsn: 'https://0c208a69dea04f499113a48c4fe7d11c@errors.brandonlehr.com/17',
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  ignoreErrors: [
    // Ignore specific error messages or patterns here
    /TagError/i,
  ],
  tracesSampleRate: 1.0,
});